/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Latest_ActivityInputs */

const en_directory_vibebids_latest_activity = /** @type {(inputs: Directory_Vibebids_Latest_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest activity`)
};

const zh_directory_vibebids_latest_activity = /** @type {(inputs: Directory_Vibebids_Latest_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新动态`)
};

/**
* | output |
* | --- |
* | "Latest activity" |
*
* @param {Directory_Vibebids_Latest_ActivityInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_latest_activity = /** @type {((inputs?: Directory_Vibebids_Latest_ActivityInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Latest_ActivityInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_latest_activity(inputs)
	return zh_directory_vibebids_latest_activity(inputs)
});
export { directory_vibebids_latest_activity as "directory.vibebids.latest_activity" }